import { combineReducers } from "redux";
import teacherListPageReducer from "./teacher-list/TeacherListReducer";
import loginPageReducer from "./login-register/LoginReducer";
import courseListPageReducer from "./course-list/CourseListReducer";
import teacherDetailPageReducer from "./teacher-detail/TeacherDetailReducer";
import myProgramPageReducer from "./my-programs/MyProgramReducer";
import profilePageReducer from "./profile/ProfileReducer";
import submitEnrollmentReducer from "./enroll-in-program/pages/enrollment/SubmitEnrollmentReducer";
import uploadDocumentReducer from "./enroll-in-program/pages/upload-documents/UploadDocumentReducer";
import profileReducer from "./enroll-in-program/pages/profile/ProfileReducer";
import receiptReducer from "./enroll-in-program/pages/receipt/ReceiptReducer";
import programReducer from "./program/ProgramReducer";
import courseReducer from "./course/CourseReducer";
import executeReducer from "./course/pages/execute-page/ExecuteReducer";
import forumReducer from "./course/pages/forum-page/ForumReducer";
import overviewReducer from "./course/pages/overview-page/OverviewReducer";
import libraryReducer from "./course/pages/library-page/LibraryReducer";
import waitingReducer from "./enroll-in-program/pages/waiting/WaitingReducer";
import homePageReducer from "./home/HomeReducer";
import examPageReducer from "./exam/ExamReducer";
import chatListPageReducer from "./chat-list/ChatListReducer";
import chatPageReducer from "./chat/ChatReducer";
import navBarReducer from "../layouts/public-navbar/NavBarReducer";
import NotificationsPageReducer from "./notifications/NotificationsReducer";
import programsListPageReducer from "./programs-list/ProgramsListReducer";
import programDetailPageReducer from "./program-detail/ProgramDetailReducer";
import InvoicesListPageReducer from "./invoices-list/InvoicesListReducer";
import InvoiceDetailPage from "./invoice-detail/InvoiceDetailReducer";

export default combineReducers({
    programDetailPage: programDetailPageReducer,
    programsListPage: programsListPageReducer,
    teacherListPage: teacherListPageReducer,
    loginPage: loginPageReducer,
    courseListPage: courseListPageReducer,
    teacherDetailPage: teacherDetailPageReducer,
    myProgramPage: myProgramPageReducer,
    profilePage: profilePageReducer,
    enrollmentPage: submitEnrollmentReducer,
    enrollmentUploadDocumentPage: uploadDocumentReducer,
    enrollmentProfilePage: profileReducer,
    enrollmentReceiptPage: receiptReducer,
    programPage: programReducer,
    coursePage: courseReducer,
    courseExecute: executeReducer,
    forum: forumReducer,
    overview: overviewReducer,
    enrollmentWaiting: waitingReducer,
    home: homePageReducer,
    exam: examPageReducer,
    chatListPage: chatListPageReducer,
    chatPage: chatPageReducer,
    navBar: navBarReducer,
    NotificationsPage: NotificationsPageReducer,
    library: libraryReducer,
    invoiceListPage: InvoicesListPageReducer,
    InvoiceDetailPage: InvoiceDetailPage
});
